import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';
import MyButton from '../../../shared-components/button/Button';
import CustomInput from '../../../shared-components/custom-input/CustomInput';

interface ReasonDetailInterface {
  reason: string;
}

interface RejectElectricPriceReasonProperties {
  id: string;
  handleCancel: () => void;
  handleRejected: (id: string, status: 'rejected', reason: string) => void;
}

/**
 * Component to get reason for rejected pricing
 * @param properties
 * @returns
 */
export default function RejectElectricPriceReason(properties: RejectElectricPriceReasonProperties) {
  const { id, handleCancel, handleRejected } = properties;
const {t} = useTranslation('station');
  const [reasonDetails, setReasonDetails] = useState<ReasonDetailInterface>({
    reason: '',
  });

  /**
   * Input filed handle change function
   */
  const handleReasonChange = (name: string, value: string | number) =>
    setReasonDetails({
      ...reasonDetails,
      [name]: value,
    });

  return (
    <div className="reject-electricity-price-reason-wrap">
      <CustomInput
        type="text"
        placeholder={t('enterReason')}
        value={reasonDetails.reason}
        name="reason"
        onChangeValue={handleReasonChange}
        inputLabel={t('enterValidReason')}
      />
      <div className="reject-electricity-price-reason-button">
        <MyButton label={t('cancel')} buttonType="back" onClickFunc={handleCancel} />
        <MyButton
          label={t('reject')}
          buttonType="error"
          disabled={reasonDetails.reason === ''}
          svgBackIcon={<Delete />}
          onClickFunc={() => handleRejected(id, 'rejected', reasonDetails?.reason)}
        />
      </div>
    </div>
  );
}
